// extracted by mini-css-extract-plugin
export default {"hint":"hint__D9w_Z","ingame":"ingame__nj1wc","foe":"foe__Ec21F","onyx":"onyx__Mhn6p","standard":"standard__D4i2A","standard-belowthefold":"standard-belowthefold__L3jYi","grepo":"grepo__AAvut","village":"village__BWdJM","mobilecity":"mobilecity__AffsE","herocity":"herocity__L1vw3","arrow":"arrow__jqFFJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"hint\":\"hint__D9w_Z\",\"ingame\":\"ingame__nj1wc\",\"foe\":\"foe__Ec21F\",\"onyx\":\"onyx__Mhn6p\",\"standard\":\"standard__D4i2A\",\"standard-belowthefold\":\"standard-belowthefold__L3jYi\",\"grepo\":\"grepo__AAvut\",\"village\":\"village__BWdJM\",\"mobilecity\":\"mobilecity__AffsE\",\"herocity\":\"herocity__L1vw3\",\"arrow\":\"arrow__jqFFJ\"}";
        // 1787130558101
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  